import Head from "next/head";

import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";
import { GetStaticProps } from "next";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";
import IntelcomMain from "@/components/fulfilment-partners/intelcom-main";

export default function Intelcom({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <IntelcomMain />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_Intelcom },
  };
};
